import { render } from "./UnauthenticatedTabs.vue?vue&type=template&id=65e0b92f&ts=true"
import script from "./UnauthenticatedTabs.vue?vue&type=script&lang=ts"
export * from "./UnauthenticatedTabs.vue?vue&type=script&lang=ts"

import "./UnauthenticatedTabs.vue?vue&type=style&index=0&id=65e0b92f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__